module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7130491bf33852e50503dcb4024c0279.svg";